export const footerMoreLinks = {
  'uz-ru': [
    {
      title: 'Больше',
      items: [
        {
          href: 'https://uz.wingie.com/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://uz.wingie.com/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://uz.wingie.com/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://uz.wingie.com/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://uz.wingie.com/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://uz.wingie.com/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'uz-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://uz.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://uz.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://uz.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://uz.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://uz.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://uz.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'uz-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://uz.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://uz.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://uz.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://uz.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://uz.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://uz.wingie.com/es/awards/',
          title: 'Nuestras premios',
        },
      ],
    },
  ],
  'uz-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://uz.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://uz.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen',
        },

        {
          href: 'https://uz.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://uz.wingie.com/de/datenschutz/',
          title: 'Datenschutz',
        },
        {
          href: 'https://uz.wingie.com/de/allgemeine-geschaftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://uz.wingie.com/de/awards/',
          title: 'Unsere Preise',
        },
      ],
    },
  ],
  'uz-ar': [
    {
      title: 'المزيد',
      items: [
        {
          href: 'https://uz.wingie.com/ar/contact/',
          title: 'اتصل بنا',
        },
        {
          href: 'https://uz.wingie.com/ar/faq/',
          title: 'الأسئلة الشائعة',
        },

        {
          href: 'https://uz.wingie.com/ar/about-us/',
          title: 'من نحن',
        },
        {
          href: 'https://uz.wingie.com/ar/privacy/',
          title: 'الخصوصية',
        },
        {
          href: 'https://uz.wingie.com/ar/terms-and-conditions/',
          title: 'الشروط والأحكام',
        },
        {
          href: 'https://uz.wingie.com/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'uz-it': [
    {
      title: 'Di più',
      items: [
        { title: 'Contatto', href: 'https://uz.wingie.com/it/contact/' },
        // { title: 'Domande frequenti', href: 'https://uz.wingie.com/it/faq/' },

        { title: 'Chi siamo', href: 'https://uz.wingie.com/it/about-us/' },
        { title: 'Privacy', href: 'https://uz.wingie.com/it/privacy/' },
        { title: 'Termini e condizioni', href: 'https://uz.wingie.com/it/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'uz-fr': [
    {
      title: 'Plus',
      items: [
        { title: 'Contact', href: 'https://uz.wingie.com/fr/contact/' },
        // { title: 'Questions fréquemment posées', href: 'https://uz.wingie.com/fr/faq/' },

        { title: 'À propos de nous', href: 'https://uz.wingie.com/fr/about-us/' },
        { title: 'Confidentialité', href: 'https://uz.wingie.com/fr/privacy/' },
        { title: 'Termes et conditions', href: 'https://uz.wingie.com/fr/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/fr/awards/', title: 'Nos prix' },
      ],
    },
  ],
  'uz-pt': [
    {
      title: 'Mais',
      items: [
        { title: 'Contacto', href: 'https://uz.wingie.com/pt/contact/' },
        // { title: 'Perguntas frequentes', href: 'https://uz.wingie.com/pt/faq/' },

        { title: 'Sobre nós', href: 'https://uz.wingie.com/pt/about-us/' },
        { title: 'Privacidade', href: 'https://uz.wingie.com/pt/privacy/' },
        { title: 'Termos e condições', href: 'https://uz.wingie.com/pt/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'uz-ro': [
    {
      title: 'Mai mult',
      items: [
        { title: 'Contact', href: 'https://uz.wingie.com/ro/contact/' },
        // { title: 'Întrebări frecvente', href: 'https://uz.wingie.com/ro/faq/' },

        { title: 'Despre noi', href: 'https://uz.wingie.com/ro/about-us/' },
        { title: 'Confidențialitate', href: 'https://uz.wingie.com/ro/privacy/' },
        { title: 'Termeni și condiții', href: 'https://uz.wingie.com/ro/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/ro/awards/', title: 'Premii noastre' },
      ],
    },
  ],
  'uz-pl': [
    {
      title: 'Więcej',
      items: [
        { title: 'Kontakt', href: 'https://uz.wingie.com/pl/contact/' },
        // { title: 'Często zadawane pytania', href: 'https://uz.wingie.com/pl/faq/' },

        { title: 'O nas', href: 'https://uz.wingie.com/pl/about-us/' },
        { title: 'Prywatność', href: 'https://uz.wingie.com/pl/privacy/' },
        { title: 'Warunki użytkowania', href: 'https://uz.wingie.com/pl/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'uz-lt': [
    {
      title: 'Daugiau',
      items: [
        { title: 'Kontaktai', href: 'https://uz.wingie.com/lt/contact/' },
        // { title: 'Dažnai užduodami klausimai', href: 'https://uz.wingie.com/lt/faq/' },

        { title: 'Apie mus', href: 'https://uz.wingie.com/lt/about-us/' },
        { title: 'Privatumas', href: 'https://uz.wingie.com/lt/privacy/' },
        { title: 'Taisyklės ir sąlygos', href: 'https://uz.wingie.com/lt/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/lt/awards/', title: 'Mūsų premijos' },
      ],
    },
  ],
  'uz-uz': [
    {
      title: "Ko'proq",
      items: [
        { title: 'Aloqa', href: 'https://uz.wingie.com/uz/contact/' },
        // { title: 'Tez-tez beriladigan savollar', href: 'https://uz.wingie.com/uz/faq/' },

        { title: 'Biz haqimizda', href: 'https://uz.wingie.com/uz/about-us/' },
        { title: 'Maxfiylik', href: 'https://uz.wingie.com/uz/privacy/' },
        { title: 'Shartlar va qoidalar', href: 'https://uz.wingie.com/uz/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'uz-sr': [
    {
      title: 'Više',
      items: [
        { title: 'Kontakt', href: 'https://uz.wingie.com/sr/contact/' },
        // { title: 'Često postavljana pitanja', href: 'https://uz.wingie.com/sr/faq/' },

        { title: 'O nama', href: 'https://uz.wingie.com/sr/about-us/' },
        { title: 'Privatnost', href: 'https://uz.wingie.com/sr/privacy/' },
        { title: 'Uslovi korišćenja', href: 'https://uz.wingie.com/sr/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/sr/awards/', title: 'Naše nagrade' },
      ],
    },
  ],
  'uz-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { title: 'Байланыш', href: 'https://uz.wingie.com/ky/contact/' },
        // { title: 'Көп берилүүчү суроолор', href: 'https://uz.wingie.com/ky/faq/' },

        { title: 'Биз жөнүндө', href: 'https://uz.wingie.com/ky/about-us/' },
        { title: 'Купуялык', href: 'https://uz.wingie.com/ky/privacy/' },
        { title: 'Эрежелер жана шарттар', href: 'https://uz.wingie.com/ky/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/ky/awards/', title: 'Биздин марапаттарымыз' },
      ],
    },
  ],
  'uz-tg': [
    {
      title: 'Бештар',
      items: [
        { title: 'Алоқа', href: 'https://uz.wingie.com/tg/contact/' },
        // { title: 'Савол-ҷавобҳои зиёд', href: 'https://uz.wingie.com/tg/faq/' },

        { title: 'Дар бораи мо', href: 'https://uz.wingie.com/tg/about-us/' },
        { title: 'Махфият', href: 'https://uz.wingie.com/tg/privacy/' },
        { title: 'Шартҳо ва қоидаҳо', href: 'https://uz.wingie.com/tg/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/tg/awards/', title: 'Биздин марапаттарымыз' },
      ],
    },
  ],
  'uz-kk': [
    {
      title: 'Көбірек',
      items: [
        { title: 'Байланыс', href: 'https://uz.wingie.com/kk/contact/' },
        // { title: 'Жиі қойылатын сұрақтар', href: 'https://uz.wingie.com/kk/faq/' },

        { title: 'Біз туралы', href: 'https://uz.wingie.com/kk/about-us/' },
        { title: 'Құпиялылық', href: 'https://uz.wingie.com/kk/privacy/' },
        { title: 'Ережелер мен шарттар', href: 'https://uz.wingie.com/kk/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/kk/awards/', title: 'Біздің марапаттарымыз' },
      ],
    },
  ],
  'uz-nl': [
    {
      title: 'Meer',
      items: [
        { title: 'Contact', href: 'https://uz.wingie.com/nl/contact/' },
        // { title: 'Veelgestelde vragen', href: 'https://uz.wingie.com/nl/faq/' },

        { title: 'Over ons', href: 'https://uz.wingie.com/nl/about-us/' },
        { title: 'Privacy', href: 'https://uz.wingie.com/nl/privacy/' },
        { title: 'Algemene voorwaarden', href: 'https://uz.wingie.com/nl/terms-and-conditions/' },
        { href: 'https://uz.wingie.com/nl/awards/', title: 'Onze prijzen' },
      ],
    },
  ],
  'uz-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://uz.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://uz.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://uz.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://uz.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://uz.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://uz.wingie.com/ja/awards/' },
      ],
    },
  ],
  'uz-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://uz.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://uz.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://uz.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://uz.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://uz.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://uz.wingie.com/zh/awards/' },
      ],
    },
  ],
  'uz-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://uz.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://uz.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://uz.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://uz.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://uz.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://uz.wingie.com/ko/awards/' },
      ],
    },
  ],
  'uz-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://uz.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://uz.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://uz.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://uz.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://uz.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://uz.wingie.com/hi/awards/' },
      ],
    },
  ],
  'uz-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://uz.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://uz.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://uz.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://uz.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://uz.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://uz.wingie.com/ta/awards/' },
      ],
    },
  ],
  'uz-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://uz.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://uz.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://uz.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://uz.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://uz.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://uz.wingie.com/th/awards/' },
      ],
    },
  ],
  'uz-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://uz.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://uz.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://uz.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://uz.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://uz.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://uz.wingie.com/ur/awards/' },
      ],
    },
  ],
  'uz-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://uz.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://uz.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://uz.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://uz.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://uz.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://uz.wingie.com/ka/awards/' },
      ],
    },
  ],
}
